module.exports = __webpack_public_path__ + "img/paper2.2ef43313.svg";